import { AsyncComboBox, type ComboBoxOption } from '../../../cdl/ComboBox/ComboBox';
import { getCustomerGroups, type GetCustomerGroupsParams } from '../../api/clients/company.api';
import { getCustomerGroup } from '../../api/clients/customerGroups.api';
import { queries } from '../../api/queryKeys/queries';
import type { AsyncSingleSelectProps } from '../AsyncSelectProps';

export interface CustomerGroupSelectProps extends AsyncSingleSelectProps {
    onChange: (customerGroupId: string | null) => void;
    value: string | null;
}

const loadCustomerGroups = async (params: GetCustomerGroupsParams): Promise<ComboBoxOption[]> => {
    const customerGroups = await getCustomerGroups(params);

    return customerGroups.map((customerGroup) => ({
        value: customerGroup.id,
        label: customerGroup.name,
    }));
};

const loadCustomerGroup = async (customerGroupId: string): Promise<ComboBoxOption | null> => {
    const customerGroup = await getCustomerGroup(customerGroupId);

    return {
        value: customerGroup.id,
        label: customerGroup.name,
    };
};

export function CustomerGroupSelect({ value, onChange, ...rest }: CustomerGroupSelectProps) {
    return (
        <AsyncComboBox
            {...rest}
            value={value || null}
            onChange={onChange}
            optionsQueryKey={(search) => queries.customerGroups.comboBoxOptions({ searchQuery: search }).queryKey}
            optionsQueryFn={(search) => loadCustomerGroups({ searchQuery: search })}
            selectedOptionQueryKey={(selectedValue) =>
                queries.customerGroups.selectedComboBoxOption(selectedValue).queryKey
            }
            selectedOptionQueryFn={loadCustomerGroup}
        />
    );
}
